module.exports = __webpack_public_path__ + "static/media/ttd-ketua-bem.470ff894.jpeg";